export const jobCandidateTypeEnum = {
  internalWorker: 'internalWorker',
  syftWorker: 'syftWorker',
  agencyShift: 'agencyShift',
}
